import NavBar from "../components/navbar";
import Footer from "../components/footer";
import {
  CalendarIcon,
  LocationMarkerIcon,
  UsersIcon,
} from "@heroicons/react/solid";
import { useEffect, useState } from "react";

import { topicListApi } from "../services/topic";

export type TopicList = {
  id: number;
  topicTitle: string;
  topicDesc: string;
};

const About = () => {
  const [topics, setTopics] = useState<TopicList[]>();

  useEffect(() => {
    const loadTopicList = async () => {
      const topicLists = await topicListApi();
      if (topicLists) {
        setTopics(topicLists.topics);
      }
    };
    loadTopicList();
  }, []);

  return (
    <>
      <NavBar />
      <div className="grid h-60 place-items-center">
        <h2>Welcome To About Page for Ask Me Anything Forum</h2>
      </div>
      <div className="grid place-items-center h-fit">
        <h4>Rules and Regulations:<br></br>
          1. Respect each other while using the Discussion Forum <br></br>
          2. No Usage of vulgarities in the Discussion Forum <br></br>
          3. If in doubt, contact support for further enquires
        </h4>
      </div>
      <Footer />
    </>
  );
};

export default About;
